/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.blockModule')
  .controller('BlockController', [
    '$rootScope',
    '$scope',
    '$state',
    '$translate',
    '$window',
    'AeroDialogService',
    'AnalyticsService',
    'AssignmentHttpService',
    'BulbAuthService',
    'BulbAvatarService',
    'BulbBlockViewSwitcherService',
    'BulbBusyService',
    'BulbBrowserService',
    'BulbErrorService',
    'BulbModalService',
    'BulbPresentationService',
    'BulbUnitService',
    'ErrorService',
    'GroupHttpService',
    'AUTH',
    'TITLE_THRESHOLD_LENGTH',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    BlockController,
  ]);

/**
 * AngularJS controller for blocks.
 */
function BlockController(
  $rootScope,
  $scope,
  $state,
  $translate,
  $window,
  AeroDialogService,
  AnalyticsService,
  AssignmentHttpService,
  BulbAuthService,
  BulbAvatarService,
  BulbBlockViewSwitcherService,
  BulbBusyService,
  BulbBrowserService,
  BulbErrorService,
  BulbModalService,
  BulbPresentationService,
  BulbUnitService,
  ErrorService,
  GroupHttpService,
  AUTH,
  TITLE_THRESHOLD_LENGTH,
) {

  this.$onInit = function () {
    const { unit } = this;
    const { groupId } = this;
    const { canUpdate } = this;
    const { pinnedUnitIds } = this;
    this.shortTitle = TITLE_THRESHOLD_LENGTH.shortenedTitleLength;
    this.isOwner = BulbAuthService.currentUser.username === unit.ownerUsername;

    this.blockType = getBlockType(unit);
    this.presentation = false;
    this.myArchiveCollectionTitle = $translate.instant('ArchiveCompositeUnit');
    this.isDeleted = unit.deleteAfterDays && unit.deleteAfterDays > 0;
    this.canOpen = !(this.isDeleted && that.blockType === 'page');
    this.getAvatarImage = BulbAvatarService.getDefaultAvatarImage;
    this.unitTypeToOpenInNewTab = BulbBlockViewSwitcherService.unitTypeToOpenInNewTab;

    $scope.viewSwitcherService = BulbBlockViewSwitcherService;
    this.isOwner = BulbAuthService.currentUser.username === this.unit.ownerUsername;
    this.canEdit = (!this.isDeleted && BulbAuthService.currentUser.hasPermission(this.unit, AUTH.PERMISSIONS.UPDATE));

    this.menuItems = [
      {
        label: $translate.instant('copy_entire_collection'),
        icon: 'copy',
        command: () => copyPage(unit),
        color: 'var(--aero-ink)',
        hidden: unit.unitType !== 'CompositeUnit' || unit.viewOnly,
      },
      {
        label: 'Unpin',
        icon: 'thumbtack-slash',
        command: () => this.unpin(groupId, unit),
        color: 'var(--aero-ink)',
        hidden: !pinnedUnitIds?.includes(unit.id) || !canUpdate,
      },
      {
        label: $translate.instant('copy_page'),
        icon: 'copy',
        command: () => copyPage(unit),
        color: 'var(--aero-ink)',
        hidden: unit.unitType === 'CompositeUnit' || unit.unitType === 'AssignmentCompositeUnit' || unit.viewOnly || !that.canEdit,
      },
      {
        label: $translate.instant('delete'),
        icon: 'trash-alt',
        command: () => that.deleteUnitModal(),
        color: 'var(--bulb-darker-red-color)',
        hidden: !that.canEdit,
      },
    ];

    this.blockTileFooterData = {
      isDeleted: this.isDeleted,
      canEdit: this.canEdit,
      unitInformation: {
        ownerDisplayName: unit.ownerDisplayName,
        deleteAfterDays: unit.deleteAfterDays,
        archivedDate: unit.archivedDate,
        unitType: unit.unitType,
        lastModified: unit.lastModified,
        publishedDate: unit.publishedDate,
        isPinned: pinnedUnitIds?.includes(unit.id),
      },
      menuItems: this.menuItems,
      authorImpliedByContext: this.authorImpliedByContext,
    };

    if (unit.unitType === 'AssignmentCompositeUnit') {
      const assignmentInformation = {
        noOfAssignments: unit.noOfAssignments,
        noOfSubmissions: unit.noOfSubmissions,
      };
      this.blockTileFooterData.assignmentInformation = assignmentInformation;
    }

    this.blockTileFooterIcons = [
      {
        iconKey: 'collection',
        visibility: unit.unitType === 'CompositeUnit',
      },
      {
        iconKey: 'assign-triple-arrow',
        visibility: unit.unitType === 'AssignmentCompositeUnit',
      },
      {
        iconKey: 'clone',
        visibility: unit.template,
      },
      {
        iconKey: 'eye',
        visibility: unit.viewCount > 0 && this.canEdit && !this.isDeleted && this.authorImpliedByContext,
        label: unit.viewCount,
      },
      {
        iconKey: 'heart-solid',
        visibility: unit.likeCount > 0 && !this.isDeleted && this.authorImpliedByContext,
        label: unit.likeCount,
      },
      {
        iconKey: 'arrow-alt-circle-up',
        visibility: !this.isDeleted && this.canEdit && unit.isModified && !unit.isPublished,
        alert: true,
        tooltip: 'tiles.tilesFooter.statusUnpublished',
      },
      {
        iconKey: 'exclamation-circle',
        visibility: !this.isDeleted && this.canEdit && unit.isModified && unit.isPublished,
        alert: true,
        tooltip: 'tiles.tilesFooter.statusModified',
      },
    ];
  };
  const { from, of } = require('rxjs');
  const that = this;
  this.init = function init() {
    // eslint-disable-next-line default-case
    switch (this.blockType) {
      case 'group':
        this.uiSref = `group({groupUrl: "${that.unit.url}"})`;
        this.avatarImage = that.unit.circularImage;
        break;
      case 'user':
        this.uiSref = `author({username: "${that.unit.ownerUsername}"})`;
        this.avatarImage = that.unit.circularImage || that.unit.ownerAvatarImage;
        this.coverImage = that.unit.coverImage;
        break;
      case 'collection':
      case 'archiveCollection':
        this.uiSref = (!this.isDeleted) ? `unit({unitPath: "${that.unit.path}"})` : '.';
        this.coverImage = that.unit.coverImage;
        break;
      case 'assignment':
        this.uiSref = (!this.isDeleted) ? `unit({unitPath: "${that.unit.path}"})` : '.';
        this.coverImage = that.unit.horizontalImage;
        break;
      case 'page':
        this.uiSref = this.presentation ? BulbPresentationService.createHref(that.unit)
          : `unit({unitPath: "${that.unit.path}"})`;
        // isModified is only set for the author, so for non-authors, the statusClass is always undefined.
        this.statusClass = 'bulb-block-modified';
        this.coverImage = that.unit.horizontalImage;
        break;
    }
  };

  this.publishStatusClick = function publishStatusClick() {
    if (!that.canOpen) {
      return false;
    }
    if (this.unit.isPublished) {
      const modalOptions = {
        titleCode: 'block_publish_status_modified_dialog_title',
        bodyCode: 'block_publish_status_modified_dialog_body',
        okButtonCode: 'block_publish_status_modified_dialog_submit_button',
        cancelButtonCode: 'button_later',
      };

      BulbModalService.show(modalOptions).then(() => {
        $state.go('unit', { unitPath: that.unit.path });
      });
    } else {
      $state.go('unit', { unitPath: that.unit.path, publish: true });
    }
  };

  /**
   * When user will try to open unit this method will be called.
   * Unit type is page and unit is deleted then show modal .
   * If unit type is collection and its deleted then broadcast event.
   */
  this.open = function open(unit) {
    if (!this.canOpen) {
      const translatedType = $translate.instant('type_draft_page_unit');
      const modalBody = $translate.instant('soft_delete_open_deleted_unit', { type: translatedType });

      BulbModalService.show({
        bodyText: modalBody,
        showCancelButton: false,
      });
    } else if (unit && unit.unitType === 'CompositeUnit' && this.isDeleted) {
      $rootScope.$broadcast('openDeletedCollection', unit);
    }
  };

  this.getTemplateUrl = function getTemplateUrl() {
    return `ajs/components/block/${
      this.tile === 'true' ? 'block-tile' : 'block'}.html`;
  };

  /**
   * This method opens the passed url in new window eg: unsplash profile of the photographer.
   * @param url the url to be opened in new tab.
   * @param event event triggerred.
   */
  this.redirectTo = function redirectTo(url, event) {
    const link = `/u/${url}`;
    $window.open(link, '_blank');
    event.stopPropagation();

    // Pushing an analytics event to count on the number of times
    // this open in new tab functionality used for groups collection.
    const openNewTab = {
      event: 'OpenGroupCollectionInNewTab',
    };

    AnalyticsService.pushEvent(openNewTab);
  };

  /**
   * Handle Key press events for the profile contents i.e. pages and collections.
   * Also added handling for recently deleted pages and collections.
   *
   * @param unit current unit to be opened.
   * @param event event triggered.
   */
  this.handleKeyPress = function handleKeyPress(unit, event) {
    that.open(unit);
    if (((event.key === 'Enter' || event.key === ' ') && this.canOpen)
      && !(unit.unitType === 'CompositeUnit' && this.isDeleted)) {
      $state.go('unit', { unitPath: unit.path });
    }
  };

  /**
   * Unpins a unit from the given group.
   * @param {string} groupId - The ID of the group from which to unpin the unit.
   * @param {Object} unit - The unit object to unpin.
   */
  this.unpin = function unpin(groupId, unit) {
    const busy = BulbBusyService.showBusy();
    GroupHttpService.unpinUnits(groupId, unit.id, GroupHttpService.activeTab !== 'assignments').subscribe(() => {
      busy();
      window.dispatchEvent(new CustomEvent('refreshView'));
    }, (error) => {
      busy();
      console.error('Error pinning unit:', error);
      // Since we have hide unpin option when they don't have access. So no translations needed.
      if (error.status === 403) {
        BulbErrorService.showError("Don't have permission to unpin this unit");
      } else {
        BulbErrorService.showError('An error occurred while unpinning the unit. Please try again.');
      }
    });
  };

  /**
   * Method that is called from deleteUnitModal. To delete a page you should call delete()
   */
  function deleteUnitWithoutModal() {
    // user confirmed the confirm delete modal
    if (that.unit.unitType === 'AssignmentCompositeUnit') {
      const busy = BulbBusyService.showBusy();
      AssignmentHttpService.deleteAssignment(that.unit.id).subscribe((res) => {
        busy();
        BulbAuthService.fetchCurrentUser();
        $state.reload();
      });
    } else {
      BulbBusyService.showBusyDuring(
        BulbUnitService.deleteUnit(that.unit).then(() => {
          BulbAuthService.fetchCurrentUser();
          $state.reload();
        }, (error) => {
          BulbErrorService.error('Cannot delete page', error);
          throw error;
        }),
      );
    }
  }

  /**
   * Shows the standard delete unit modal, private function. To delete a page you should call delete()
   */
  this.deleteUnitModal = function deleteUnitModal() {
    let translatedType;
    if (that.unit['@c'] === '.CompositeUnitDTO' && that.unit.unitType === 'CompositeUnit') {
      translatedType = $translate.instant('type_composite_unit');
    } else if (that.unit['@c'] === '.CompositeUnitDTO' && that.unit.unitType === 'AssignmentCompositeUnit') {
      translatedType = $translate.instant('AssignmentCompositeUnit');
    } else {
      translatedType = $translate.instant('type_draft_page_unit');
    }
    const typeToLowercase = translatedType.toLowerCase();

    AeroDialogService.showDialog({
      icon: 'far fa-trash-alt',
      iconClass: 'aero-alert',
      title: $translate.instant('modal_delete_confirm_title', { type: typeToLowercase }),
      detail: $translate.instant('modal_delete_confirm_body', { type: typeToLowercase }),
      primaryLabel: $translate.instant('button_delete'),
      primaryStyle: AeroDialogService.getButtonStyleEnum().NEGATIVE_ACTION,
      onPrimary: () => {
        deleteUnitWithoutModal();
      },
    });
  };

  const copyPage = (page) => {
    BulbUnitService.copyPageUnit(page, false)
      .then(() => {
        $state.reload();
      }, (error) => {
        ErrorService.captureAnyError(error, true);
        BulbErrorService.showError($translate.instant(error.data.developerMessage));
      });
  };
}

/**
 * Determines a block type from the given unit
 * @param unit
 * @returns String a string constant representing this block's type
 */
function getBlockType(unit) {
  switch (unit.unitType) {
    case 'CompositeUnit':
      return 'collection';
    case 'ArchiveCompositeUnit':
      return 'archiveCollection';
    case 'DraftPageUnit':
    case 'PublishedPageUnit':
    case 'ArchivePageUnit':
      return 'page';
    case 'GroupUnit':
      return 'group';
    case 'UserUnit':
      return 'user';
    case 'AssignmentCompositeUnit':
      return 'assignment';
    default:
      return unit.unitType;
  }
}
